import MarketLayoutDescriptors from './_market-layout-descriptors.js'
import ShowAllSelectionsButton from './_show-all-selections-button.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SelectionHeaders from './_selection-headers.js'
import Market from './_market.js'

export default {
  name: 'GenericMarketContent',
  values: {
    layoutDescriptors: {
      configSet: MarketLayoutDescriptors,
      configValues: {
        default: {
          selectionTypes: [
            '1',
            '2',
          ],
        },
      },
    },
    showAllSelectionsButton: {
      configSet: ShowAllSelectionsButton,
      configValues: {},
    },
    rowsThreshold: 10,
    numberOfExpandedRows: 8,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          flexBasis: '100%',
        },
      },
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    eachWayTermsLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 4px',
        },
      },
    },
    selectionHeaders: {
      configSet: SelectionHeaders,
      configValues: {},
    },
    market: {
      configSet: Market,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
